import * as React from 'react'

/**
 * @description ThumbUp icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ThumbUp } from '@sravni/design-system-icons'
 *
 * <ThumbUp />
 * ```
 */
export const ThumbUp = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="ThumbUp" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3 7.675v8.853M9.649 3.678 6 8.429v6.528l1.232 1.326a1.8 1.8 0 0 0 1.318.574h6.289a1.8 1.8 0 0 0 1.729-1.302l1.359-4.722a1.8 1.8 0 0 0-.234-1.499l-.329-.491a1.8 1.8 0 0 0-1.496-.799h-3.096V4.773c0-.416-.144-.82-.409-1.141a1.734 1.734 0 0 0-2.714.046Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
